// extracted by mini-css-extract-plugin
export default {"body":"StatFundVolume_body__M3Xwy","title":"StatFundVolume_title__x2w9a","title-underline":"StatFundVolume_title-underline__RKI8P","chart-block":"StatFundVolume_chart-block__qCJjo"};